'use strict';
const angular = require('angular');

export class contactFormComponent {
  /*@ngInject*/
  constructor(MailsService, dialogs) {
    this.MailsService = MailsService;
    this.dialogs = dialogs;
  }

  submitContactForm() {
    this.MailsService.contact({
      firstName: this.firstName,
      lastName: this.lastName,
      email: this.email,
      phone: this.phone,
      message: this.message
    }, () => {
      this.firstName = '';
      this.lastName = '';
      this.email = '';
      this.phone = '';
      this.message = '';

      this.dialogs.notify("Your message has been sent","Your message has been sent.<br/>Thank you for contacting us!");
    });
  }
}

export default angular.module('conduuApp.contactForm', [])
  .component('contactForm', {
    template: require('./contact-form.component.html'),
    bindings: {

    },
    controller: contactFormComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/contact-form/contact-form.component.js